import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { HeaderComponent } from '../../../shared/components/header/header.component';
import { FooterComponent } from '../../../shared/components/footer/footer.component';
import { ChallengeCardComponent, ChallengeCardData } from '../challenge-card/challenge-card.component';

@Component({
  selector: 'app-challenge-card-demo',
  standalone: true,
  imports: [CommonModule, RouterLink, HeaderComponent, FooterComponent, ChallengeCardComponent],
  templateUrl: './challenge-card-demo.component.html',
  styleUrl: './challenge-card-demo.component.scss',
})
export class ChallengeCardDemoComponent {
  sampleData: ChallengeCardData = {
    id: 'demo-1',
    name: 'Test Discussion',
    description: 'Predict crop yields based on historical data and weather patterns.',
    provider: 'Predict crop yields using ML',
    imageUrl: 'https://images.unsplash.com/photo-1464226184884-fa280b87c399?w=400&h=200&fit=crop',
    participants: 45,
    submissions: 12,
    prizeMoney: 250000,
    daysRemaining: 5,
    submissionStartsAt: '2025-01-15',
    submissionEndsAt: '2025-02-20',
    link: '/challenges/demo-1',
  };

  formatPrize(amount: number): string {
    return `₹${amount.toLocaleString('en-IN')}`;
  }

  formatDays(days: number): string {
    if (days === 1) return '1 day left';
    if (days === 0) return 'Deadline today';
    return `${days} days left`;
  }

  getImageUrl(): string {
    return this.sampleData.imageUrl || 'https://images.unsplash.com/photo-1464226184884-fa280b87c399?w=400&h=200&fit=crop';
  }
}
